(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ModelEquation', ModelEquation);

    ModelEquation.$inject = ['$resource'];

    function ModelEquation ($resource) {
        var resourceUrl =  'api/model-equations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
